import React from 'react'
import { NavLink } from 'react-router-dom'
import { Nav, Navbar } from '@softwaredev_cegeka/stix-core'
import UserMenu from 'src/components/Header/UserMenu'
import { reverse } from 'src/routes/config'
import logo from 'src/assets/images/logo-white.png'
import './header.scss'

const Header = () => {
    return (
        <Navbar fixed={'top'} sticky={'top'} bg={'primary'} variant={'dark'}>
            <Navbar.Brand href={reverse('home')}>
                <img src={logo} alt={'logo'} className={'logo'} />
            </Navbar.Brand>
            <Nav>
                <NavLink
                    className={'stix-nav-link'}
                    to={reverse('products-overview')}
                >
                    Products
                </NavLink>
                <NavLink
                    className={'stix-nav-link'}
                    to={reverse('contracts-overview')}
                >
                    Contracts
                </NavLink>
                <NavLink
                    className={'stix-nav-link'}
                    to={reverse('costs-overview')}
                >
                    Costs
                </NavLink>
            </Nav>
            <Navbar.Right>
                <UserMenu />
            </Navbar.Right>
        </Navbar>
    )
}

export default Header
